import { render, staticRenderFns } from "./RLVSubmitDocument.vue?vue&type=template&id=bd8f7a86&scoped=true"
import script from "./RLVSubmitDocument.vue?vue&type=script&lang=js"
export * from "./RLVSubmitDocument.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/component/panel-simple.css?vue&type=style&index=0&id=bd8f7a86&prod&scoped=true&lang=css&external"
import style1 from "./RLVSubmitDocument.vue?vue&type=style&index=1&id=bd8f7a86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8f7a86",
  null
  
)

export default component.exports